import {format as formatDate} from "date-fns"

export const DATE_ONLY_ISO = "yyyy-MM-dd";

export const DATE_ONLY_DISPLAY = "MMMM d, yyyy";

export const DATE_TIME = "dd/MM/yyyy HH:mm";

type FormattableDateType = Date | number | string

export const formatDateOnlyISO = (date: FormattableDateType) => formatDate(date, DATE_ONLY_ISO);

export const formatDateOnlyDisplay = (date: FormattableDateType) => formatDate(date, DATE_ONLY_DISPLAY);

export const formatDateTime = (date: FormattableDateType) => formatDate(date, DATE_TIME);
